module.exports = __webpack_public_path__ + "h5/img/ball-down.43cbbe67.png";